module.exports = __webpack_public_path__ + "img/cn-pro.3cfb62d3.png";